import React from "react";
import { Alert, Button, Card, Checkbox, Col, Form, Input, Row, Space } from "antd";
import { Rules } from "../../../common/AsyncValid";
import { observer } from "mobx-react";
import { Store } from "../../../store/Store";

export const AddUserFromEmailPanel = observer(({ onSelect, selectText }) => {
  const [form] = Form.useForm();
  const store = Store.orgsStore.orgView.addUserFromEmailStore;

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };

  return (
    <Card>
      <Form form={form} {...layout} initialValues={{}}>
        <Form.Item label="Email" name="email" rules={Rules.email}>
          <Input.Search
            placeholder="Enter user's email"
            onSearch={(val) => store.onSearch(val)}
            allowClear
            loading={store.loading}
          />
        </Form.Item>
      </Form>
      {store.user && (
        <Space direction="vertical" style={{width:'100%'}}>
          <div>
            {store.user.title} {store.user.name}
          </div>
          <div>Confirm Children School Membership</div>
          {store.user.children.map((c) => (
            <Row key={c.childId}>
              <Col span={12}>
                <Checkbox checked={c.checked} disabled={c.disabled} onChange={(e) => (c.checked = e.target.checked)}>
                  {c.name}
                  {c.grade ? `(${c.grade})` : ""}
                </Checkbox>
              </Col>
              <Col span={8}>{c.school?.name || "None"}</Col>
              <Col span={4}></Col>
            </Row>
          ))}
          <Alert type="warning" message="Please select children to join this School"></Alert>
          <Button type="primary" size="large" disabled={!store.canSave} onClick={() => store.onSave()}>
            Confirm Add
          </Button>
        </Space>
      )}
    </Card>
  );
});
